
export default {
  name: 'SectionSelector',
  props: {
    section: {
      required: true,
      type: String,
      default: ''
    },
    variant: {
      required: false,
      type: String,
      default: ''
    },
    multiProject: {
      required: false,
      type: Boolean,
      default: false
    },
    data: {
      required: true,
      type: Object | Array,
      default: function () {
        return {}
      }
    },
    orderNo: {
      required: true,
      type: Number,
      default: 0
    },
    enabled: {
      required: false,
      type: Boolean,
      default: false
    },
    hash: {
      required: true,
      type: String,
      default: ''
    },
    project: {
      required: true,
      type: Object,
      default: function () {
        return {}
      }
    },
    offer: {
      required: true,
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  computed: {
    activeDataSet() {
      if (this.multiProject) {
        return this.data[this.project.slug]
      }
      return this.data
    }
  }
}
